import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCurrencySymbol } from '@shared/hooks';
import { FormatUtils, RoutePaths } from '@shared/utils';
import { CardKing, type CardResponse } from '@shared/api/rest/cards';
import { AccountType } from '@shared/api/rest/accounts';
import { ModalDeleteConfirmation } from '../modals';
import { Button, ColorsEnum, Icon, Text } from '@shared/widgets';
import VisaIcon from '@assets/icons/card/visa.svg';
import MastercardIcon from '@assets/icons/card/mastercard.svg';
import TrashIcon from '@assets/icons/trash.svg';

export interface ISmallCardProps {
  card: CardResponse;
  removeCard: (id: number) => void;
}

export const SmallCard = (props: ISmallCardProps) => {
  const [isViewModal, setIsViewModal] = useState<boolean>(false);
  const symbol = useCurrencySymbol(props.card.currency);

  return (
    <>
      <div className='mb-6 flex items-center border-b border-b-gray-black pb-6 last:mb-0 last:border-none last:pb-0'>
        <Link
          className='mr-4 flex h-10 w-16 flex-none items-center justify-center rounded-lg bg-soft-black p-2 text-center dark:bg-gray-wet-asphalt'
          to={RoutePaths.card.onNavigate(props.card.cardId)}
        >
          {props.card.cardKind === CardKing.Credit && <Icon icon={<VisaIcon />} color='white' />}
          {props.card.cardKind === CardKing.Debit && <Icon icon={<MastercardIcon className='h-full w-full' />} />}
        </Link>
        <div className='flex-auto pr-3'>
          <Text className='overflow-hidden text-ellipsis' weight='medium' size='xs' color={ColorsEnum.Secondary} uppercase>
            {FormatUtils.toSliceNumber(props.card.cardNumber)}
          </Text>
          <Text className='overflow-hidden text-ellipsis' weight='medium'>
            {symbol}
            {props.card.balance}
          </Text>
        </div>
        <Button color='icon' onClick={() => setIsViewModal(true)}>
          <Icon icon={<TrashIcon />} />
        </Button>
      </div>
      {isViewModal && (
        <ModalDeleteConfirmation onClose={() => setIsViewModal(false)} type={AccountType.Card} onDelete={props.removeCard} id={props.card.cardId} />
      )}
    </>
  );
};
